import { BuildingMenuType } from '@/enums';
import { PATHS } from '@/router/paths';

export const DEFAULT_MENUS = [
    {
        type: BuildingMenuType.HOME,
        route: PATHS.HOME.INDEX,
    },
    {
        type: BuildingMenuType.FLOOR,
        route: PATHS.FLOOR_GUIDE.INDEX,
    },
    {
        type: BuildingMenuType.SEARCH,
        route: PATHS.SHOP.INDEX,
    },
];

export const MENU_CUSTOM = [
    {
        type: BuildingMenuType.EVENT,
        route: PATHS.EVENTS.INDEX,
    },
    {
        type: BuildingMenuType.PARKING,
        route: PATHS.PARKING.INDEX,
    },
    {
        type: BuildingMenuType.FACILITIES,
        route: PATHS.FACILITY.INDEX,
    },
    {
        type: BuildingMenuType.FAQ,
        route: PATHS.FAQ.INDEX,
    },
];

export const JAMSIL_MAP_IDS = ['e2048cd2-68f3-44fd-8310-0c30a43f6092'];

export const STORE_CODE_MAP_JAMSIL = '0002';
